import { isEmpty } from 'lodash'
import { Link } from 'react-router-dom'
import { Box, Breadcrumbs, Stack, Typography } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import useReactRouterBreadcrumbs from 'use-react-router-breadcrumbs'
import Menu from 'components/menu/menu'
import MenuLink from 'assets/menu.json'
import BreadcrumbStyle from './style'

const Breadcrumb = () => {
    const crumbs = useReactRouterBreadcrumbs()
    const breadcrumbs = crumbs.length > 1 ? crumbs.slice(1) : crumbs

    const currentPath = breadcrumbs[breadcrumbs.length - 1].key

    type MenuItem = { name: string; path: string; menu?: MenuItem[] }
    const findByPath = (items: MenuItem[], path: string): MenuItem | undefined => {
        for (const item of items) {
            if (item.path === path) return item
            const found = findByPath(item.menu ?? [], path)
            if (found) return found
        }
    }

    const matched = findByPath(MenuLink as MenuItem[], currentPath)
    const current = MenuLink.find((menu) =>
        breadcrumbs.some((bread) => menu.path == bread.key) ||
        (menu.menu ?? []).some((sub) => breadcrumbs.some((bread) => sub.path == bread.key))
    )
    const title = (current && current.name) || breadcrumbs[breadcrumbs.length - 1].breadcrumb
    const titleStr = matched?.name ?? (typeof title === 'string' ? title : String(title))

    return (
        <>
            <Helmet>
                <title>{titleStr} - MyHyundai Admin</title>
            </Helmet>
            <Box {...BreadcrumbStyle.Container}>
                <Typography {...BreadcrumbStyle.Title}>{title}</Typography>
                <Stack>
                    <Breadcrumbs separator='›' aria-label='breadcrumb' sx={{ textTransform: 'lowercase' }}>
                        {breadcrumbs.map(({ breadcrumb, key }, index) => (
                            <Link key={index} {...BreadcrumbStyle.Link} to={key}>
                                {breadcrumb}
                            </Link>
                        ))}
                    </Breadcrumbs>
                </Stack>
            </Box>
            {!isEmpty(current) && !isEmpty(current.menu) && <Menu menu={current?.menu ?? []} />}
        </>
    )
}

export default Breadcrumb
